var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    { staticClass: "eu-mt_5 eu-mb_3", attrs: { hasPadding: "" } },
    [
      _c("div", { staticClass: "timeline-onboarding" }, [
        _c("div", { staticClass: "timeline-onboarding__img--container" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/timeline-onboarding/trophy.svg").default,
            },
          }),
        ]),
        _c(
          "div",
          { staticClass: "timeline-onboarding__text--container" },
          [
            _c(
              "jade-text",
              {
                attrs: {
                  color: "neutral",
                  "data-testid": "text-timeline-title",
                  variant: "text-large",
                  weight: "semibold",
                },
              },
              [_vm._v(_vm._s(_vm.$t("fullActivation.title")) + " ")]
            ),
            _c(
              "jade-text",
              {
                attrs: {
                  color: "medium",
                  variant: "text-medium",
                  weight: "regular",
                },
              },
              [
                _vm._v(_vm._s(_vm.$t("fullActivation.description")) + " "),
                _c(
                  "jade-text",
                  {
                    attrs: {
                      href: _vm.$sanitize(_vm.blogURL),
                      as: "a",
                      color: "current-color",
                      rel: "noopener noreferrer",
                      target: "_blank",
                      weight: "semibold",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("fullActivation.blog")))]
                ),
                _c(
                  "jade-text",
                  { attrs: { as: "span", color: "current-color" } },
                  [_vm._v(_vm._s(_vm.$t("fullActivation.descriptionPart2")))]
                ),
                _c(
                  "jade-text",
                  {
                    attrs: {
                      href: _vm.$sanitize(_vm.helpURL),
                      as: "a",
                      color: "current-color",
                      target: "_blank",
                      weight: "semibold",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("fullActivation.helpCenter")) + " ")]
                ),
                _c(
                  "jade-text",
                  { attrs: { as: "span", color: "current-color" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("fullActivation.descriptionPart3")) + " "
                    ),
                  ]
                ),
                _c(
                  "jade-text",
                  {
                    attrs: {
                      as: "span",
                      color: "current-color",
                      weight: "semibold",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("fullActivation.phone")) + " ")]
                ),
                _c(
                  "jade-text",
                  { attrs: { as: "span", color: "current-color" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("fullActivation.descriptionPart4")) + " "
                    ),
                  ]
                ),
                _c(
                  "jade-text",
                  {
                    attrs: {
                      as: "span",
                      color: "current-color",
                      weight: "semibold",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("fullActivation.email")) + " ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "timeline-onboarding__close--container" },
          [
            _c("jade-button", {
              attrs: {
                icon: "close",
                size: "medium",
                variant: "neutral-ghost",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.closeFullActivation.apply(null, arguments)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }